import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {SedeEntity, ServicioSedesService} from '../../../../services/servicio-sedes.service';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-header-movimiento-paciente-by-rango-fecha',
  templateUrl: './header-movimiento-paciente-by-rango-fecha.component.html',
  styleUrls: ['./header-movimiento-paciente-by-rango-fecha.component.css']
})
export class HeaderMovimientoPacienteByRangoFechaComponent implements OnInit {

  @Input() codigoBaseDatos: string;
  @Input() uncoSede: number;

  @Output() errorGenerado: EventEmitter<any>;
  @Output() filtrosSeleccionados: EventEmitter<any>;

  sedesItem: SelectItem[] = [];

  sedesSelected: any[];

  fechaInicial: Date = new Date();
  fechaFinal: Date = new Date();

  mensajeError: string;

  mensajeLoading: string;

  constructor(private servicioSede: ServicioSedesService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();
  }

  ngOnInit() {
    this.getSedes();
  }

  onGenerar() {
    this.filtrosSeleccionados.emit({
      ln_unco_sede : this.sedesSelected.join(),
      ln_fec_ini : this.fechaInicial,
      ln_fec_fin : this.fechaFinal
    });
  }
  async getSedes() {

    this.mensajeLoading = 'Cargando sedes...';
    const response = await this.servicioSede.getSedes(this.codigoBaseDatos);

    response.subscribe((sedes: SedeEntity[]) => {

      this.sedesSelected = [];
      sedes.forEach((s: SedeEntity) => {
        this.sedesItem.push({ label: s.descripcion.toUpperCase(), value: s.unco});
      });
      this.mensajeLoading = null;
    }, (err: HttpErrorResponse) => {
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al intentar cargar las sedes, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      this.clearSedes();
      console.error('Error HeaderMovimientoPacienteByRangoFechaComponent.getSedes()', err);
    });
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );

    popupWin.document.close();
  }

  private clearSedes() {
    this.sedesSelected = [];
  }

}
